// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"99cf86eb","418":"7c5f2c83"}[chunkId] + ".chunk.css";
};